/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { connect } from 'inferno-redux';
// actions used to manipulate application state
import { advanceFrame, saveContentSkipResponse, submitUDCData } from 'redux/actions/content_status';
// actual presentational component that will utilize application state and actions (will be exported after being infused with state/actions)
import Skip from 'components/shared/skip/skip';



/* ========== ~~~~~~~~~~ SHARE : PARENT ~~~~~~~~~~ ========== */
// CONTAINER COMPONENT
// interacts with redux (store of application state)
// infuses child component (imported above) with state & actions by mapping and then connecting them

// map state
// map state
const mapStateToProps = ({ settings, contentStatus, sessionStatus, queueStatus, contentData }, { contentId }) => {
    const currentContentData = contentData[contentId];
    const currentContentStatus = contentStatus[contentId];
    const contentType = currentContentStatus.type;
    const currentContentSettings = settings.contentSettings[contentId];
    const currentUniqueState = currentContentStatus.uniqueState;
    const frame = contentStatus[contentId].frame;
    const frameState = contentType === 'mixed' && !!currentUniqueState.frameStatus ? currentUniqueState.frameStatus[frame].state : null;
    const framePhase = contentType === 'userDataCollection' && !!currentUniqueState.phase ? currentUniqueState.phase : null;
    const frameData = currentContentData.data[frame];
    const isPubPortalPreview = settings.embedSettings.isPubPortalPreview;

    return {
        currentContentStatus,
        currentContentSettings,
        currentUniqueState,
        contentType,
        frameData,
        frameState,
        framePhase,
        isPubPortalPreview,
        canSkipFrames: currentContentSettings.canSkipFrames,
        cookieId: sessionStatus.userInfo.userId,
        embedUUID: settings.embedSettings.embedUUID
    }
};

// map actions
const mapDispatchToProps = dispatch => ({
	advanceFrame: contentId => dispatch(advanceFrame(contentId)),
    saveContentSkipResponse: (contentId, responseData, isPubPortalPreview, callback) =>
        dispatch(saveContentSkipResponse(contentId, responseData, isPubPortalPreview, callback)),
    submitUDCData: (contentId, udcData, isPubPortalPreview, callback) =>
        dispatch(submitUDCData(contentId, udcData, isPubPortalPreview, callback)),
});



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
// utilizes "connect" functionality from redux in order to infuse state/actions as props to child component
// will be utilized from any component that wants to incorporate "Content" component
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Skip);
